"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_SUBSCRIPTION_STATUS = exports.CUSTOMER_SUBSCRIPTION_CANCEL_STATUS = void 0;
exports.CUSTOMER_SUBSCRIPTION_CANCEL_STATUS = {
    CANCELED: 'CANCELED',
    TERMINATED: 'TERMINATED'
};
exports.CUSTOMER_SUBSCRIPTION_STATUS = Object.assign(Object.assign({}, exports.CUSTOMER_SUBSCRIPTION_CANCEL_STATUS), { ACTIVE: 'ACTIVE', EXPIRING: 'EXPIRING', EXPIRED: 'EXPIRED', SUSPENDED: 'SUSPENDED', FAILED: 'FAILED' });
//# sourceMappingURL=customerSubscriptionStatus.js.map